import React from "react";

type PaginationProps = {
  pageIndex: number;
  setPageIndex: (updateFunction: (currentPage: number) => number) => void;
  isPreviousPageAvailable: boolean;
  isNextPageAvailable: boolean;
};

const Pagination: React.FC<PaginationProps> = ({
  pageIndex,
  setPageIndex,
  isPreviousPageAvailable,
  isNextPageAvailable,
}) => {
  return (
    <div className="btn-group">
      <button
        className="btn"
        onClick={() => setPageIndex((current) => Math.max(0, current - 1))}
        disabled={!isPreviousPageAvailable}
      >
        «
      </button>
      <button
        className="btn"
        onClick={() => setPageIndex((current) => current + 1)}
        disabled={!isNextPageAvailable}
      >
        »
      </button>
    </div>
  );
};

export default Pagination;
